<template>
  <b-col class="">
    <b-row v-if="items.length">
      <b-col cols="12">
        <headerPdf title="مهارت فردی" />
      </b-col>
      <b-col cols="12">
        <ul v-for="(item, i) in items" :key="i">
          <li>
            {{ item.skill_caption }}
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import headerPdf from "../headerPdf.vue";

export default {
  name: "Skills",
  components: {
    headerPdf,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.information-pro {
  font-size: 14px;
  font-weight: 500;
  color: #282c52;
}
</style>
